export class PanelMemberRequest {
  reportId: number;
  personId: number;
  reportRole: string;
}
